import { applyMiddleware, compose, createStore } from "redux";
import { DefaultRootState } from "react-redux";
import { History, createMemoryHistory } from "history";
import { reducer } from "./redux.store";
import { routerMiddleware } from "connected-react-router";
import isBrowserContext from "helpers/isBrowserContext";
import isDevelopment from "helpers/isDevelopment";
import thunk from "redux-thunk";

const tmpStore: any = undefined;

const configureStore = (initialState?: DefaultRootState, history?: History): any => {
    if (!history) {
        history = createMemoryHistory();
    }

    const middleware = [
        thunk,
        routerMiddleware(history)
    ];

    const composeEnhancers = isBrowserContext() && isDevelopment() && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

    const enhancer = composeEnhancers(
        applyMiddleware(...middleware)
    );

    const tmpStore = createStore(
        reducer(history),
        enhancer
    );

    return tmpStore;
};

export type AppDispatch = typeof store.dispatch;
export const store = tmpStore;

export default configureStore;